var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#masterCard';
                    var viewUrl = 'svg/global.svg#view-masterCard';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 46 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };